export const composeTranslatedMessage = (message: string, argsArray: string[]) => {
  let temp = message;
  for (let index = 0; index < argsArray.length; index++) {
    const placeholder = argsArray[index];
    temp = temp.replace(`{${index}}`, placeholder);
  }

  return temp;
};
